"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.axiosSerializerobjectToQueryParams = exports.IsDateYYYYMMDD = void 0;
const class_validator_1 = require("class-validator");
const IsDateYYYYMMDD = (validationOptions) => {
    return function (object, propertyName) {
        (0, class_validator_1.registerDecorator)({
            name: 'IsDateYYYYMMDD',
            target: object.constructor,
            propertyName: propertyName,
            constraints: [],
            options: Object.assign({ message: 'Correct date format is YYYY-MM-DD' }, validationOptions),
            validator: {
                validate(value) {
                    const regex = /^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))$/;
                    return typeof value === 'string' && regex.test(value);
                },
            },
        });
    };
};
exports.IsDateYYYYMMDD = IsDateYYYYMMDD;
function privateserializerObjectToQueryParam(params, options, prefixe = '', first = true) {
    let result = '';
    for (const cle in params) {
        if (typeof params[cle] === 'object' && params[cle] !== null && !first) {
            result += privateserializerObjectToQueryParam(params[cle], options, `${prefixe}[${cle}]`, false);
        }
        else if (typeof params[cle] === 'object' && params[cle] !== null && first) {
            result += privateserializerObjectToQueryParam(params[cle], options, `${prefixe}${cle}`, false);
        }
        else if (first) {
            result += `${prefixe}${cle}=${params[cle]}&`;
        }
        else {
            result += `${prefixe}[${cle}]=${params[cle]}&`;
        }
    }
    return result;
}
function axiosSerializerobjectToQueryParams(params, options, prefixe = '', first = true) {
    return privateserializerObjectToQueryParam(params, options, prefixe, first).slice(0, -1);
}
exports.axiosSerializerobjectToQueryParams = axiosSerializerobjectToQueryParams;
